import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import FbInit from './FbInit';
import Common from '../../Common';
import { window } from 'browser-monads';

class FbComment extends Component {
    componentDidUpdate(prevProps, prevState) {
        try {
            setTimeout(()=> {
                window.FB.XFBML.parse()
            }, 2000)
        } catch {
            console.debug("Cannot run RB.XFBML parse")
        }
    }

    componentDidMount () {
        FbInit.addIfNeeded();
    }

    render() {
        let url = Common.getCurrentPageUrl()

        return (
            <Row className="mb-3 mt-3">
                <Col xs="12">
                    <div id="fb-root"></div>

                    <div key={url} className="text-center">
                        <div className="fb-comments" data-href={url} data-numposts="5" data-width=""></div>
                    </div>
                </Col>
            </Row>
        )
    }
}


export default FbComment;